$('#call_date').on('click focus', function () {
	if (typeof this.showPicker === 'function') this.showPicker()
})